// 全职兼职的判断

import tool from '@tool';

export default class TimeType {

  /**
   * 是否全职
   */
  static isFullTimeType(timeType) {
    if (tool.isNil(timeType)) {
      return false;
    }

    if (['1', '2'].indexOf(timeType.toString()) != -1) {
      return true;
    }

    return false;
  }

  /**
   * 是否兼职
   */
  static isPartTimeType(timeType) {
    if (tool.isNil(timeType)) {
      return false;
    }

    if (['0', '3'].indexOf(timeType.toString()) != -1) {
      return true;
    }

    return false;
  }

  /**
   * 获取全职或兼职字符串
   */
  static timeType(timeType) {
    if (tool.isNil(timeType)) {
      return '';
    }

    if (['0', '3'].indexOf(timeType.toString()) != -1) {
      return 'part';
    }

    if (['1', '2'].indexOf(timeType.toString()) != -1) {
      return 'full';
    }

    return '';
  }

}
